function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import AccesoServicios from 'src/_panel/module/uni-base/services/AccesoServicios';
export var RestClient = /*#__PURE__*/function () {
  function RestClient(AccesoServicios, baseurl, resource, idprop) {
    _classCallCheck(this, RestClient);
    this.AccesoServicios = AccesoServicios;
    this.baseurl = baseurl;
    this.resource = resource;
    this.idprop = idprop;
  }
  return _createClass(RestClient, [{
    key: "_getListado",
    value: function _getListado(listado) {
      return listado._embedded[this.resource];
    }
  }, {
    key: "findAll",
    value: function findAll() {
      var _this = this;
      return this.AccesoServicios._call('GET', this.baseurl, null, null, 'Fallo 1').then(function (listado) {
        return _this._getListado(listado);
      });
    }
  }, {
    key: "save",
    value: function save(item) {
      var _id = this.idprop(item);
      return this.AccesoServicios._call('PUT', this.baseurl + '/' + _id, item, null, 'Fallo save');
    }
  }, {
    key: "add",
    value: function add(item) {
      return this.AccesoServicios._call('POST', this.baseurl, item, null, 'Fallo add');
    }
  }, {
    key: "delete",
    value: function _delete(item) {
      return this.AccesoServicios._call('DELETE', this.baseurl, item, null, 'Fallo delete');
    }
  }]);
}();